import { get } from "lodash";

import { generalHelpers } from "../helpers";
import { scheduleServices } from "../services";
import { showToaster } from "../helpers/toaster.helpers";

export const createSchedule = async (payload, userOffline) => {
  if (userOffline) {
    return showToaster(
      "error",
      "You are offline, please check your internet connection"
    );
  }
  try {
    const res = await scheduleServices.createSchedule(payload);
    return get(res, "data.data", {});
  } catch (error) {
    generalHelpers.handleError(error);
    return {};
  }
};

export const fetchSchedules = async (userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    const { data } = await scheduleServices.fetchSchedules();

    return get(data, "data", "");
  } catch (error) {
    generalHelpers.handleError(error);
    return [];
  }
};

export const updateSchedule = async (scheduleId, payload, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    await scheduleServices.updateSchedule(scheduleId, payload);
    return true;
  } catch (error) {
    generalHelpers.handleError(error);
    return false;
  }
};

export const deleteSchedule = async (playlistId, userOffline) => {
  if (userOffline) {
    return;
  }
  try {
    await scheduleServices.deteleSchedule(playlistId);
    return true;
  } catch (error) {
    generalHelpers.handleError(error);
    return false;
  }
};
